export default __webpack_public_path__ + "static/media/rocket_anim_150.d6b3c4ec.png";